<div [formGroup]="parentForm">
  <div>
    <div class="fx-flex-25">
      <div class="mb-4">
        Partner Affiliation
      </div>
    </div>
    <div class="fx-flex-75" formArrayName="partnerPermissions">
      @for (partner of companyPartners; track partner) {
        <app-single-partner-affiliation
          [parentForm]="parentForm"
          [partnerFormGroup]="partner.formGroup"
          [partnerAffiliationData]="partner.data"
          [affiliationTypes$]="availableAffiliations$">
        </app-single-partner-affiliation>
      }
    </div>
  </div>
  <div class="row footer">
    <mat-card-actions align="end" class="col save-container">
      <button mat-flat-button class="mat-text-btn" type="button" (click)="addEmptyAffiliationForm()"
        [disabled]="partnerPermissionsFormArray.controls.length >= affiliationTypes.length"><mat-icon>add</mat-icon> Add Another Affiliation</button>
        <button mat-raised-button color="primary" type="button" [disabled]="parentForm.invalid || !parentForm.dirty"
        (click)="onSubmit()">Save</button>
      </mat-card-actions>
    </div>
  </div>